import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  query QueryData($tenantId: ID!, $zoneId: ID!, $query: AWSJSON!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        data(query: $query)
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.QueryDataQuery,
    unknown,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'data',
        graphql.transformers.OUT.pipe(
          graphql.transformers.OUT.json({
            onNullish: 'preserve',
          }),
          graphql.transformers.OUT.custom(ents.core.dms.data.Value.fromJson),
        ),
      ),
    ),
  ),
  [],
)

export const execute = graphql.createExecutor<
  graphql.schema.QueryDataQuery,
  unknown,
  graphql.schema.QueryDataQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
